module.exports = __webpack_public_path__ + "static/media/introduce_more1.ca3eeaf9.png";